import React from "react";
import { Header } from "@/components/Header/Header";
import { Footer } from "@/components/Footer/Footer";

export const Layout = ({ children, lightHeader = true }) => {
    return (
        <main>
            <Header lightHeader={lightHeader} />
            {children}
            <Footer />
        </main>
    );
};
